const React = require('react')

import {
  Dropdown,
  MenuItem,
  Glyphicon,
  Row,
  Col
} from 'react-bootstrap'
import { isMobile } from 'react-device-detect'

import DropdownSelector from '../shared/DropdownSelector'
import BoostSubjectDropdownSelector from './BoostSubjectDropdownSelector'
export default class SiteSearchFilters extends React.Component {
  containerRef = React.createRef();

  _emptyFilters = () => {
    this.props.onFilterClear('selectedSubject')
    this.props.onFilterClear('selectedYear')
    this.props.onFilterClear('selectedCurriculumVersion')
    this.props.onFilterClear('selectedCurriculumView')
    this.props.onFilterClear('selectedLearningSkill')
    this.props.onFilterClear('selectedContentStandard')
    this.props.onFilterClear('selectedSyllabus')
    this.props.onFilterClear('selectedUnit')
  }

  render() {
    const filterView = (
      <div className="btn-group w-full" ref={this.containerRef}>
        {!isMobile && 
          <div className="btn-group">
            <div className="btn btn-static no-border">
              Filter By:
            </div>
          </div>
        }
        <DropdownSelector
          containerRef={this.containerRef}
          noun="year"
          onClear={() => this.props.onFilterClear('selectedYear')}
          onSelect={(item) => this.props.onFilterChange(item, 'selectedYear')}
          items={this.props.years}
          selectedItem={this.props.selectedYear}
        />
        {this.props.selectedYear &&
          <BoostSubjectDropdownSelector
            noun="subject"
            onClear={() => this.props.onFilterClear('selectedSubject')}
            onSelect={(item) => this.props.onFilterChange(item, 'selectedSubject')}
            items={this.props.subjects}
            selectedItem={this.props.selectedSubject}
          />
        }
        {this.props.selectedSubject && this.props.showCurriculumVersionSelection == 1 &&
          <DropdownSelector
            containerRef={this.containerRef}
            noun="curriculum"
            onClear={() => this.props.onFilterClear('selectedCurriculumVersion')}
            onSelect={(item) => this.props.onFilterChange(item, 'selectedCurriculumVersion')}
            items={this.props.curriculumVersions}
            selectedItem={this.props.selectedCurriculumVersion}
          />
        }
        {this.props.selectedCurriculumVersion && this.props.showCurriculumViewSelection == 1 &&
          <DropdownSelector
            containerRef={this.containerRef}
            noun="view"
            onClear={() => this.props.onFilterClear('selectedCurriculumView')}
            onSelect={(item) => this.props.onFilterChange(item, 'selectedCurriculumView')}
            items={this.props.views}
            selectedItem={this.props.selectedCurriculumView}
          />
        }
        {this.props.selectedCurriculumVersion && this.props.selectedCurriculumView && this.props.selectedCurriculumView.id == 'curriculum' &&
          <DropdownSelector
            containerRef={this.containerRef}
            noun="skill/topic"
            onClear={() => this.props.onFilterClear('selectedLearningSkill')}
            onSelect={(item) => this.props.onFilterChange(item, 'selectedLearningSkill')}
            items={this.props.currentLearningSkills}
            selectedItem={this.props.selectedLearningSkill}
            disabledText="Select a year, subject and curriculum version"
            disabled={!this.props.selectedSubject || !this.props.selectedYear || !this.props.selectedCurriculumVersion}
            direction={this.props.selectedSubject ? this.props.selectedSubject.direction : ''}
          />
        }
        {this.props.selectedLearningSkill && this.props.selectedCurriculumView.id == 'curriculum' &&
          <DropdownSelector
            containerRef={this.containerRef}
            noun="content standard"
            onClear={() => this.props.onFilterClear('selectedContentStandard')}
            onSelect={(item) => this.props.onFilterChange(item, 'selectedContentStandard')}
            items={this.props.currentContentStandards}
            selectedItem={this.props.selectedContentStandard}
            disabledText="Select a skill/topic"
            disabled={!this.props.selectedLearningSkill}
            direction={this.props.selectedSubject ? this.props.selectedSubject.direction : 'ltr'}
          />
        }
        {this.props.selectedCurriculumVersion && this.props.selectedCurriculumView && this.props.selectedCurriculumView.id == 'syllabus' &&
          <DropdownSelector
            containerRef={this.containerRef}
            noun="syllabus"
            onClear={() => this.props.onFilterClear('selectedSyllabus')}
            onSelect={(item) => this.props.onFilterChange(item, 'selectedSyllabus')}
            items={this.props.currentSyllabuses}
            selectedItem={this.props.selectedSyllabus}
            disabledText="Select a year, subject and curriculum version"
            disabled={!this.props.selectedSubject || !this.props.selectedYear || !this.props.selectedCurriculumVersion}
            direction={this.props.selectedSubject ? this.props.selectedSubject.direction : ''}
          />
        }
        {this.props.selectedSyllabus && this.props.selectedCurriculumView.id == 'syllabus' &&
          <DropdownSelector
            containerRef={this.containerRef}
            noun="unit"
            onClear={() => this.props.onFilterClear('selectedUnit')}
            onSelect={(item) => this.props.onFilterChange(item, 'selectedUnit')}
            items={this.props.currentUnits}
            selectedItem={this.props.selectedUnit}
            disabledText="Select a syllabus"
            disabled={!this.props.selectedSyllabus}
            direction={this.props.selectedSubject ? this.props.selectedSubject.direction : 'ltr'}
          />
        }
        {this.props.selectedCollection &&
          <Dropdown id='collection' bsStyle='link'>
            <Dropdown.Toggle bsStyle='link'>
              <Glyphicon glyph='star' />&nbsp;
              {this.props.selectedCollection.name}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <MenuItem
                eventKey={1}
                onSelect={this.props.onCollectionClear}
              >Reset</MenuItem>
            </Dropdown.Menu>
          </Dropdown>
        }
      </div>
    );

    return filterView
  }
}